import i18n from '@/i18n/index'
// import constant from '@/utils/constant.js'
export default {
  formData: [{
    title: i18n.t('form.store.generalInformation'),
    name: 0,
    createDateItem: [{
      span: 24,
      prop: 'current',
      value: false,
      name: 'switch',
      label: i18n.t('form.members.defaultAddress'),
      Object: {}
    }, {
      span: 12,
      prop: 'name',
      name: 'input',
      label: i18n.t('form.members.addressee'),
      Object: {}
    }, {
      span: 12,
      prop: 'phone_number',
      name: 'input',
      label: i18n.t('form.members.phoneNumber'),
      Object: {}
    }, {
      span: 12,
      prop: 'postal_code',
      name: 'input',
      label: i18n.t('form.members.postalCode'),
      Object: {}
    }, {
      span: 12,
      prop: 'road_name',
      name: 'input',
      label: i18n.t('form.members.roadName'),
      Object: {}
    }, {
      span: 12,
      prop: 'building_name',
      name: 'input',
      label: i18n.t('form.members.buildingName'),
      Object: {}
    }, {
      span: 12,
      prop: 'block_number',
      name: 'input',
      label: i18n.t('form.members.blockNumber'),
      Object: {}
    }, {
      span: 12,
      prop: 'unit_no',
      name: 'input',
      label: i18n.t('form.members.unitNo'),
      Object: {}
    }, {
      span: 12,
      prop: 'address_type_id',
      name: 'select',
      options: [],
      label: i18n.t('form.members.addressType'),
      placeholder: i18n.t('placeholder.defaultSelect'),
      Object: {
        filterable: true,
        label: 'name',
        value: 'id'
      }
    }, {
      span: 12,
      prop: 'business_type',
      name: 'select',
      options: [],
      label: i18n.t('form.members.residentialType'),
      placeholder: i18n.t('placeholder.defaultSelect'),
      Object: {
        label: 'label'
      }
    }, {
      span: 24,
      prop: 'address_name',
      name: 'input',
      label: i18n.t('form.members.address'),
      Object: {
        visible: 'business_type',
        visibleValue: 'business'
      }
    }]
  }]
}
